import { mapCatalogResultDto, type CatalogResultDto } from '@/types';

import type { CatalogService } from '../catalogService';
import { httpRequestWithRefresh, type HttpClientConfig } from './httpApiClient';
import { unwrapResult } from './httpEnvelope';

/**
 * HTTP impl of :type:`CatalogService`(P3 — 對齊 docs/44 FE 整合契約)
 * -----------------------------------------------------------------------------
 * 單一 endpoint:`GET /api/workflow/catalog`
 *   - 需登入(httpOnly cookie;未登入 401)、GET 免 CSRF、純讀。
 *   - **全域非 project-scope**;不掛 L1.5 group context(catalog 跟 group 無關)。
 *   - BE response envelope `{ result: { schema_version, tools, nodes } }`;
 *     `mapCatalogResultDto` normalize `models` 缺值補 `[]`。
 *   - R426(docs/139)`?locale=zh-TW|en|ja`:範本 / 模特兒顯示字的語系。值域外 BE 回 422,
 *     所以只收 `AppLocale`;舊後端忽略未知 query → 不用能力宣告,直接送。
 *
 * 範本對齊 `httpMeService`(單一 GET + unwrap result + 缺 result throw)。
 */

const PATH = '/api/workflow/catalog';

export function createHttpCatalogService(config: HttpClientConfig): CatalogService {
  return {
    async get(opts) {
      const path = opts?.locale ? `${PATH}?locale=${encodeURIComponent(opts.locale)}` : PATH;
      const env = await httpRequestWithRefresh<CatalogResultDto>(config, 'GET', path);
      return mapCatalogResultDto(unwrapResult(env, 'catalog.get'));
    },
  };
}
